document.addEventListener('DOMContentLoaded', function() {
  
  /* Flexible Content Video Trigger and Quotes Video click on wistia video to launch full screen */
  
  // Variable to store video source
  var videoSrc;
  
  // when the modal is opened autoplay it
  const youtubeModal = document.getElementById('youtubeModal');
  if (youtubeModal) {
    youtubeModal.addEventListener('shown.bs.modal', function(e) {
      // set the video src to autoplay and not to show related video
      document.getElementById('video').setAttribute('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
    });
    
    // stop playing the youtube video when closing the modal
    youtubeModal.addEventListener('hide.bs.modal', function(e) {
      // a poor man's stop video
      document.getElementById('video').setAttribute('src', videoSrc);
    });
  }

  /* Homepage Video click on for youtube video to launch in Bootstrap modal */
  const videoButtons = document.querySelectorAll('.video-btn');
  videoButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      videoSrc = this.dataset.src;
    });
  });

  const videoLaunchImages = document.querySelectorAll('.video-launch-img');
  videoLaunchImages.forEach(function(img) {
    img.addEventListener('click', function(e) {
      e.preventDefault();
      let targetVideo = this.dataset.videoId;
      const videoElement = document.getElementById(targetVideo);
      if (videoElement) {
        const imgParentDiv = videoElement.querySelector('img').parentElement;
        imgParentDiv.click();
      }
    });
  });
});